import React from 'react';
import styled from 'styled-components';

const Panel = styled.div`
  background: #f6f8fa;
  border-bottom: 1px solid #e1e4e8;
  display: flex;
  flex-direction: column;
  overflow: ${props => props.$collapsed ? 'visible' : 'hidden'};
  flex: ${props => props.$collapsed ? '0 0 auto' : '1'};
`;

const Title = styled.h3`
  margin: 0;
  padding: 12px;
  font-size: 13px;
  font-weight: 600;
  color: #24292f;
  display: flex;
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid #e1e4e8;
  background: #ffffff;
  flex-shrink: 0;
  cursor: move;
  user-select: none;
  
  &:hover {
    background: #f6f8fa;
  }
`;

const CollapseIcon = styled.span`
  margin-left: auto;
  cursor: pointer;
  padding: 4px;
  transition: transform 0.2s;
  transform: ${props => props.$collapsed ? 'rotate(-90deg)' : 'rotate(0deg)'};
  
  &:hover {
    background: rgba(0,0,0,0.1);
    border-radius: 3px;
  }
`;

const SuggestionList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

const Suggestion = styled.div`
  background: white;
  border: 1px solid #d1d5da;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

const SuggestionText = styled.div`
  flex: 1;
  font-size: 12px;
  color: #24292f;
`;

const AddButton = styled.button`
  padding: 6px 12px;
  background: #2da44e;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  
  &:hover {
    background: #2c974b;
  }
`;

const EmptyState = styled.div`
  font-size: 12px;
  color: #586069;
  text-align: center;
  padding: 20px;
`;

function SuggestionsPanel({ suggestions, onApplySuggestion, collapsed, onToggle, draggable, onDragStart, onDragOver, onDragEnd }) {
  return (
    <Panel $collapsed={collapsed}>
      <Title
        draggable={draggable}
        onDragStart={onDragStart}
        onDragOver={onDragOver}
        onDragEnd={onDragEnd}
      >
        💡 Suggestions {suggestions && suggestions.length > 0 && `(${suggestions.length})`}
        <CollapseIcon $collapsed={collapsed} onClick={(e) => { e.stopPropagation(); onToggle && onToggle(); }}>
          ▼
        </CollapseIcon>
      </Title>
      {!collapsed && <SuggestionList>
        {!suggestions || suggestions.length === 0 ? (
          <EmptyState>No suggestions - your spec looks good!</EmptyState>
        ) : (
          suggestions.map((suggestion, index) => (
            <Suggestion key={index}>
              <SuggestionText>{suggestion.message}</SuggestionText>
              {suggestion.apply && (
                <AddButton onClick={() => onApplySuggestion(suggestion)}>
                  Add it
                </AddButton>
              )}
            </Suggestion>
          ))
        )}
      </SuggestionList>}
    </Panel>
  );
}

export default SuggestionsPanel;
